// Store listing identifiers for the mobile app — mirrors
// marginpal-mobile/src/config/storeConfig.js. Keep in sync when publishing.

// TODO: set to the numeric App Store ID from App Store Connect (e.g. '1234567890').
export const APP_STORE_ID = null;

// TODO: confirm when publishing — must match marginpal-mobile app.json > android.package.
export const ANDROID_PACKAGE = 'co.uk.marginpal.app';

// TODO: flip to true once BOTH the App Store and Google Play listings are live.
// Until then, the mobile-app download banner and Apple Smart App Banner meta
// tag stay hidden so we don't send users to dead listings.
export const IS_APP_PUBLISHED = false;

export function iosStoreUrl() {
  if (!APP_STORE_ID) return null;
  return `https://apps.apple.com/app/id${APP_STORE_ID}`;
}

export function androidStoreUrl() {
  if (!ANDROID_PACKAGE) return null;
  return `https://play.google.com/store/apps/details?id=${ANDROID_PACKAGE}`;
}
